/**
 * VATPAN Contact Us — gizli Shopify Forms senkron + gerçek gönderim sonucu bekleme.
 * Custom Cabinet dosyalarına dokunulmaz; mantık referans alınmıştır.
 */
(function () {
  'use strict';

  var DEBUG =
    typeof window !== 'undefined' &&
    /(?:\?|&)vatpan_contact_debug=1(?:&|$)/.test(window.location.search || '');

  function debugLog() {
    if (!DEBUG || !console || !console.log) return;
    var args = ['[VATPAN contact]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function labelMatches(text, needle) {
    var n = (needle || '').trim().toLowerCase();
    if (!n || !text) return false;
    var t = text.replace(/\s+/g, ' ').trim().toLowerCase();
    if (t === n) return true;
    if (n.length <= 4) {
      try {
        var re = new RegExp('(^|\\s)' + escapeRegExp(n) + '(\\s|$|:)', 'i');
        return re.test(t);
      } catch (e) {
        return t.indexOf(n) !== -1;
      }
    }
    return t.indexOf(n) !== -1;
  }

  function pickSelectOption(select, value) {
    var v = String(value == null ? '' : value).trim();
    if (!v || !select || select.tagName !== 'SELECT') return false;
    var vl = v.toLowerCase();
    var i;
    for (i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var ov = String(opt.value || '').trim();
      var ot = String(opt.textContent || '').replace(/\s+/g, ' ').trim();
      if (ov === v || ot === v || ot.toLowerCase() === vl) {
        select.selectedIndex = i;
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    for (i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      var tl = String(o.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (tl && (tl.indexOf(vl) !== -1 || vl.indexOf(tl) !== -1)) {
        select.selectedIndex = i;
        select.value = o.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function setFormFieldValue(el, value) {
    if (!el || el.disabled) return false;
    var tag = el.tagName;
    if (tag === 'SELECT') {
      return pickSelectOption(el, value);
    }
    if (tag === 'TEXTAREA' || tag === 'INPUT') {
      if (el.type === 'file' || el.type === 'button' || el.type === 'submit') return false;
      el.value = value == null ? '' : value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function trySetChoiceInContainer(container, value) {
    var v = String(value == null ? '' : value).trim();
    if (!v || !container) return false;
    var vl = v.toLowerCase();

    var sel = container.querySelector && container.querySelector('select');
    if (sel && pickSelectOption(sel, v)) return true;

    var triggers = container.querySelectorAll
      ? container.querySelectorAll(
          '[role="combobox"], [aria-haspopup="listbox"], [aria-haspopup="true"]'
        )
      : [];
    for (var t = 0; t < triggers.length; t++) {
      try {
        triggers[t].click();
      } catch (e) {}
    }

    var found = false;
    forEachFormSubroot(container, function (subroot) {
      if (found) return;
      subroot
        .querySelectorAll(
          '[role="option"], [role="radio"], input[type="radio"], option, label, button, li'
        )
        .forEach(function (el) {
          if (found) return;
          var text = (
            el.textContent ||
            el.getAttribute('aria-label') ||
            el.getAttribute('value') ||
            ''
          )
            .replace(/\s+/g, ' ')
            .trim();
          if (!text) return;
          var tl = text.toLowerCase();
          if (tl !== vl && tl.indexOf(vl) === -1 && vl.indexOf(tl) === -1) return;
          try {
            if (el.tagName === 'INPUT' && el.type === 'radio') {
              el.checked = true;
            }
            el.click();
            el.dispatchEvent(new Event('change', { bubbles: true }));
            found = true;
          } catch (err) {}
        });
    });
    return found;
  }

  function setByLabelWithChoice(form, needle, value) {
    if (!form || !needle) return false;
    var n = needle.trim().toLowerCase();
    if (!n) return false;
    var matched = false;
    forEachFormSubroot(form, function (subroot) {
      if (matched) return;
      var labels = subroot.querySelectorAll('label');
      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
        if (!labelMatches(text, n)) continue;

        var fid = label.getAttribute('for');
        if (fid) {
          var byId = null;
          forEachFormSubroot(form, function (sr) {
            if (byId) return;
            try {
              var hit = sr.querySelector('#' + CSS.escape(fid));
              if (hit && hit !== label) byId = hit;
            } catch (e) {}
          });
          if (byId && setFormFieldValue(byId, value)) {
            matched = true;
            return;
          }
        }

        var wrap = label.parentElement;
        var attempts = 0;
        while (wrap && wrap !== form && attempts < 14) {
          if (trySetChoiceInContainer(wrap, value)) {
            matched = true;
            return;
          }
          var input = wrap.querySelector(
            'select, input:not([type="file"]):not([type="submit"]):not([type="button"]), textarea'
          );
          if (input && setFormFieldValue(input, value)) {
            matched = true;
            return;
          }
          wrap = wrap.parentElement;
          attempts++;
        }
      }
    });
    return matched;
  }

  function forEachFormSubroot(form, fn) {
    if (!form) return;
    var stack = [form];
    while (stack.length) {
      var node = stack.pop();
      fn(node);
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) stack.push(el.shadowRoot);
      });
    }
  }

  function setByLabelSubstring(form, needle, value) {
    if (!form || !needle) return false;
    var n = needle.trim().toLowerCase();
    if (!n) return false;
    var matched = false;
    forEachFormSubroot(form, function (subroot) {
      if (matched) return;
      var labels = subroot.querySelectorAll('label');
      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
        if (!labelMatches(text, n)) continue;

        var fid = label.getAttribute('for');
        if (fid) {
          var byId = null;
          forEachFormSubroot(form, function (sr) {
            if (byId) return;
            try {
              var hit = sr.querySelector('#' + CSS.escape(fid));
              if (hit && hit !== label) byId = hit;
            } catch (e) {}
          });
          if (byId && setFormFieldValue(byId, value)) {
            matched = true;
            return;
          }
        }

        var wrap = label.parentElement;
        var attempts = 0;
        while (wrap && wrap !== form && attempts < 12) {
          var input = wrap.querySelector(
            'input:not([type="file"]):not([type="submit"]):not([type="button"]), textarea, select'
          );
          if (input && setFormFieldValue(input, value)) {
            matched = true;
            return;
          }
          wrap = wrap.parentElement;
          attempts++;
        }
      }
    });
    return matched;
  }

  function normalizePhoneE164(raw) {
    var s = String(raw == null ? '' : raw).trim().replace(/\s+/g, '');
    if (!s) return '';
    if (s.indexOf('+') === 0) return s;
    var digits = s.replace(/\D/g, '');
    if (digits.length === 10 && digits[0] === '5') return '+90' + digits;
    if (digits.length === 11 && digits[0] === '0' && digits[1] === '5') return '+90' + digits.slice(1);
    if (digits.length >= 10) return '+' + digits;
    return s;
  }

  function findFormInHost(host) {
    if (!host) return null;
    var f = host.querySelector('form');
    if (f) return f;
    var els = host.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.shadowRoot) {
        f = el.shadowRoot.querySelector('form');
        if (f) return f;
        var inner = el.shadowRoot.querySelectorAll('*');
        for (var j = 0; j < inner.length; j++) {
          if (inner[j].shadowRoot) {
            f = inner[j].shadowRoot.querySelector('form');
            if (f) return f;
          }
        }
      }
    }
    return null;
  }

  function findContactFormsHost() {
    var contact =
      document.querySelector('section.shopify-section.vatpan-contact-page-outer') ||
      document.querySelector('.vatpan-contact-page-outer.shopify-section');
    if (!contact) return { host: null, form: null };
    var next = contact.nextElementSibling;
    if (!next) return { host: null, form: null };
    return { host: next, form: findFormInHost(next) };
  }

  function setByLabelNeedles(form, needles, value, useChoice) {
    if (!form || value == null || value === '') return false;
    var list = typeof needles === 'string' ? needles.split(',') : needles;
    for (var i = 0; i < list.length; i++) {
      var n = String(list[i] || '').trim();
      if (!n) continue;
      if (useChoice && setByLabelWithChoice(form, n, value)) return true;
      if (setByLabelSubstring(form, n, value)) return true;
      if (setByLabelWithChoice(form, n, value)) return true;
    }
    return false;
  }

  function syncSubjectField(form, root, subjectValue) {
    var labelSubject = (root.dataset.labelSubject || 'subject').trim();
    var needles = [labelSubject, 'subject', 'konu'];
    var ok = setByLabelNeedles(form, needles, subjectValue, true);
    debugLog('subject sync', { value: subjectValue, ok: ok });
    return ok;
  }

  function blurAllFields(form) {
    forEachFormSubroot(form, function (subroot) {
      subroot.querySelectorAll('input, textarea, select').forEach(function (el) {
        try {
          el.dispatchEvent(new Event('blur', { bubbles: true }));
        } catch (e) {}
      });
    });
  }

  function countInvalidInputs(form) {
    var n = 0;
    forEachFormSubroot(form, function (subroot) {
      subroot.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (el.willValidate !== false && !el.disabled && !el.validity.valid) n++;
      });
    });
    return n;
  }

  function collectErrorMessages(form, host) {
    var msgs = [];
    var seen = {};
    function addMsg(m) {
      m = String(m || '').replace(/\s+/g, ' ').trim();
      if (!m || m.length < 3 || seen[m]) return;
      seen[m] = true;
      msgs.push(m);
    }

    var roots = [form];
    if (host) roots.push(host);
    roots.forEach(function (root) {
      if (!root) return;
      forEachFormSubroot(root, function (subroot) {
        subroot
          .querySelectorAll(
            '[role="alert"], [aria-live="assertive"], [class*="error"], [class*="Error"]'
          )
          .forEach(function (el) {
            var t = (el.textContent || '').trim();
            if (t && t.length < 400) addMsg(t);
          });
        subroot.querySelectorAll('input, textarea, select').forEach(function (el) {
          if (el.validity && !el.validity.valid && el.validationMessage) {
            addMsg(el.validationMessage);
          }
        });
      });
    });
    return msgs;
  }

  function hasSuccessIndicator(form, host) {
    var needles = [
      'thank you',
      'thanks for',
      'message sent',
      'submitted',
      'we received',
      'successfully',
      'teşekkür',
      'gönderildi',
    ];
    var roots = [form, host];
    var found = false;
    roots.forEach(function (root) {
      if (!root || found) return;
      forEachFormSubroot(root, function (subroot) {
        if (found) return;
        var text = (subroot.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        for (var i = 0; i < needles.length; i++) {
          if (text.indexOf(needles[i]) !== -1) {
            found = true;
            return;
          }
        }
      });
    });
    return found;
  }

  function waitForSubmissionOutcome(form, host, options) {
    var timeoutMs = (options && options.timeoutMs) || 10000;
    var pollMs = (options && options.pollMs) || 250;
    var startInvalid = countInvalidInputs(form);

    return new Promise(function (resolve) {
      var started = Date.now();

      function finish(result) {
        debugLog('submit outcome', result);
        resolve(result);
      }

      function tick() {
        if (hasSuccessIndicator(form, host)) {
          finish({ success: true, reason: 'success-ui' });
          return;
        }

        var errors = collectErrorMessages(form, host);
        if (errors.length) {
          finish({ success: false, reason: 'validation', message: errors[0], errors: errors });
          return;
        }

        var invalidNow = countInvalidInputs(form);
        if (invalidNow > startInvalid) {
          finish({
            success: false,
            reason: 'invalid-fields',
            message: 'Some required fields in Shopify Forms are still invalid.',
          });
          return;
        }

        if (Date.now() - started >= timeoutMs) {
          if (invalidNow === 0 && startInvalid === 0) {
            finish({ success: true, reason: 'timeout-assume-ok' });
          } else {
            finish({
              success: false,
              reason: 'timeout',
              message: 'Submission could not be confirmed. Please try again.',
            });
          }
          return;
        }

        setTimeout(tick, pollMs);
      }

      setTimeout(tick, 400);
    });
  }

  function showBanner(el, text) {
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-visible');
  }

  function hideBanners(ok, warn) {
    if (ok) ok.classList.remove('is-visible');
    if (warn) warn.classList.remove('is-visible');
  }

  function setSubmitting(btn, submitting, labelSending, labelDefault) {
    if (!btn) return;
    if (submitting) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-sending');
      if (labelSending) btn.textContent = labelSending;
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-sending');
      if (labelDefault) btn.textContent = labelDefault;
    }
  }

  function initContactForm(root) {
    var cfgId = (root.dataset.cfgId || '').trim();
    if (!cfgId) return;

    var jsonLabel = (root.dataset.formsJsonLabel || 'VATPAN contact (JSON)').trim();
    var summaryLabel = (root.dataset.formsSummaryLabel || 'VATPAN contact (summary)').trim();

    var $ = function (suffix) {
      return root.querySelector('#' + CSS.escape(cfgId + '-' + suffix));
    };

    var okBanner = $('sync-ok');
    var warnBanner = $('sync-warn');
    var submitBtn = $('submit');
    if (!submitBtn) return;

    var submitLabelDefault = submitBtn.textContent;
    var msgSending = root.dataset.msgSending || 'Sending...';
    var msgValidation =
      root.dataset.msgValidation ||
      'Shopify Forms could not validate the submission. Check name, Surname, e-mail and project details in Forms.';

    function contactPayload() {
      var first = String(($('first-name') && $('first-name').value) || '').trim();
      var last = String(($('last-name') && $('last-name').value) || '').trim();
      return {
        created: new Date().toLocaleString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
        firstName: first,
        lastName: last,
        name: [first, last].filter(Boolean).join(' '),
        company: String(($('company') && $('company').value) || '').trim(),
        email: String(($('email') && $('email').value) || '').trim(),
        phone: String(($('phone') && $('phone').value) || '').trim(),
        country: String(($('country') && $('country').value) || '').trim(),
        subject: String(($('subject') && $('subject').value) || '').trim(),
        message: String(($('message') && $('message').value) || '').trim(),
      };
    }

    function contactSummaryText(c) {
      return [
        '--- VATPAN Contact ---',
        'Created: ' + c.created,
        'Name: ' + c.name,
        'First name: ' + c.firstName,
        'Last name: ' + c.lastName,
        'Company: ' + c.company,
        'Email: ' + c.email,
        'Phone: ' + c.phone,
        'Country: ' + c.country,
        'Subject: ' + c.subject,
        'Message: ' + c.message,
      ].join('\n');
    }

    function validate() {
      var c = contactPayload();
      if (!c.firstName) {
        $('first-name') && $('first-name').focus();
        return false;
      }
      if (!c.lastName) {
        $('last-name') && $('last-name').focus();
        return false;
      }
      if (!c.company) {
        $('company') && $('company').focus();
        return false;
      }
      if (!c.email) {
        $('email') && $('email').focus();
        return false;
      }
      if (!c.country) {
        $('country') && $('country').focus();
        return false;
      }
      if (!c.message) {
        $('message') && $('message').focus();
        return false;
      }
      return true;
    }

    function syncToShopifyForms() {
      var located = findContactFormsHost();
      var form = located.form;
      var host = located.host;

      if (!form) {
        var main = document.querySelector('main') || document.body;
        form =
          main.querySelector('.shopify-app-block form') ||
          main.querySelector('[class*="shopify-forms"] form') ||
          main.querySelector('form');
        host = form && form.closest('.shopify-section') ? form.closest('.shopify-section') : null;
      }

      if (!form) {
        return { ok: false, form: null, host: null, sync: {} };
      }

      var c = contactPayload();
      var jsonStr = JSON.stringify(c);
      var summaryStr = contactSummaryText(c);
      var phoneVal = normalizePhoneE164(c.phone);
      var detailsLabel = (root.dataset.labelMessage || 'project details').trim();

      var labelFirst = (root.dataset.labelFirst || 'name').trim();
      var labelLast = (root.dataset.labelLast || 'Surname').trim();
      var labelCompany = (root.dataset.labelCompany || 'company').trim();
      var labelEmail = (root.dataset.labelEmail || 'e-mail').trim();
      var labelPhone = (root.dataset.labelPhone || 'number').trim();
      var labelCountry = (root.dataset.labelCountry || 'country').trim();
      var labelSubject = (root.dataset.labelSubject || 'subject').trim();

      var sync = {
        first: setByLabelNeedles(form, [labelFirst, 'name', 'ad', 'first name', 'firstname'], c.firstName),
        last: setByLabelNeedles(form, [labelLast, 'Surname', 'surname', 'soyad', 'last name', 'lastname'], c.lastName),
        company: setByLabelNeedles(form, [labelCompany, 'company', 'şirket adı', 'şirket'], c.company),
        email: setByLabelNeedles(form, [labelEmail, 'e-mail', 'email', 'e-posta'], c.email),
        phone: setByLabelNeedles(form, [labelPhone, 'number', 'phone', 'telefon', 'whatsapp'], phoneVal),
        country: setByLabelNeedles(form, [labelCountry, 'country', 'ülke'], c.country),
        subject: syncSubjectField(form, root, c.subject),
        details: false,
        json: false,
        summary: false,
      };

      var detailsNeedles = [
        detailsLabel,
        'project details',
        'your message',
        'proje detayları',
      ];
      sync.details = setByLabelNeedles(form, detailsNeedles, summaryStr);

      if (!sync.details) {
        var combined = summaryStr + '\n\n--- JSON ---\n' + jsonStr;
        sync.details = setByLabelNeedles(form, detailsNeedles, combined);
      }

      sync.json = setByLabelNeedles(
        form,
        [jsonLabel, 'VATPAN contact (JSON)', 'contact (JSON)'],
        jsonStr
      );
      sync.summary = setByLabelNeedles(
        form,
        [summaryLabel, 'VATPAN contact (summary)', 'contact (summary)'],
        summaryStr
      );

      var okRequired = sync.first && sync.last && sync.email && sync.details;

      debugLog('sync', sync, { okRequired: okRequired });

      return {
        ok: okRequired,
        okDetails: sync.details,
        sync: sync,
        form: form,
        host: host,
      };
    }

    submitBtn.addEventListener('click', function () {
      hideBanners(okBanner, warnBanner);
      if (!validate()) {
        showBanner(
          warnBanner,
          root.dataset.msgRequired || 'Please fill in all required fields.'
        );
        return;
      }

      var submitting = false;

      function attempt(i) {
        var r = syncToShopifyForms();
        if (!r.form && i < 10) {
          setTimeout(function () {
            attempt(i + 1);
          }, 350);
          return;
        }
        if (!r.form) {
          showBanner(
            warnBanner,
            root.dataset.msgNoForm ||
              'Shopify Forms bloğu bulunamadı. contact_form_apps bölümünde Forms (inline) olduğundan emin olun.'
          );
          return;
        }
        if (!r.ok && i < 10) {
          setTimeout(function () {
            attempt(i + 1);
          }, 350);
          return;
        }
        if (!r.ok) {
          showBanner(
            warnBanner,
            root.dataset.msgMismatch ||
              'Shopify Forms ile eşleşmedi. Forms’ta name, Surname, e-mail ve project details başlıklarının tema ayarlarıyla aynı olduğundan emin olun.'
          );
          debugLog('mismatch', r.sync);
          return;
        }

        if (submitting) return;
        submitting = true;
        setSubmitting(submitBtn, true, msgSending, submitLabelDefault);

        blurAllFields(r.form);

        function doSubmit() {
          var cNow = contactPayload();

          function fireSubmit() {
            var submitted = false;
            try {
              r.form.requestSubmit();
              submitted = true;
            } catch (err) {
              var sb = r.form.querySelector('button[type="submit"], button:not([type])');
              if (sb) {
                sb.click();
                submitted = true;
              }
            }

            if (!submitted) {
              submitting = false;
              setSubmitting(submitBtn, false, null, submitLabelDefault);
              showBanner(
                warnBanner,
                root.dataset.msgSubmitFail ||
                  'Could not submit automatically. Please refresh and try again.'
              );
              return;
            }

            waitForSubmissionOutcome(r.form, r.host, { timeoutMs: 12000 }).then(function (outcome) {
            submitting = false;
            setSubmitting(submitBtn, false, null, submitLabelDefault);

            if (outcome.success) {
              showBanner(
                okBanner,
                root.dataset.msgSuccess || 'Your message has been sent. Thank you.'
              );
              return;
            }

            var errText =
              outcome.message ||
              (outcome.reason === 'validation' ? msgValidation : root.dataset.msgSubmitFail);
            showBanner(warnBanner, errText);
            });
          }

          syncSubjectField(r.form, root, cNow.subject);
          setTimeout(function () {
            syncSubjectField(r.form, root, cNow.subject);
            fireSubmit();
          }, 180);
        }

        setTimeout(doSubmit, 120);
      }

      attempt(0);
    });
  }

  function boot() {
    document.querySelectorAll('[data-vatpan-contact-form]').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
